import { Link, Text, View } from "@react-pdf/renderer";

import { styles } from "../../Tables";

export const TableRowDezSrEvdListaDefinisanihTacakaHeader: React.FC<{
  naziv: string;
  vrsta: string;
  primjena: string;
  upustvoZaUpotrebu: string;
  slika: string;
}> = ({ naziv, vrsta, primjena, upustvoZaUpotrebu, slika }) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text>{naziv}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{vrsta}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{primjena}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{upustvoZaUpotrebu}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{slika}</Text>
    </View>
  </View>
);

export const TableRowDezSrEvdListaDefinisanihTacaka: React.FC<{
  naziv: string;
  vrsta: string;
  primjena: string;
  upustvoZaUpotrebu: string;
  slika?: string;
  slikares: string;
}> = ({ naziv, primjena, upustvoZaUpotrebu, slika, vrsta, slikares }) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{naziv}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{vrsta}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{primjena}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{upustvoZaUpotrebu}</Text>
    </View>
    <View style={styles.tableCol}>
      {slika && (
        <Link src={slika} style={{ ...styles.tableCell, ...styles.link }}>
          {slikares}
        </Link>
      )}
    </View>
  </View>
);
